import { useEffect, useCallback } from 'react'
import { useBucket } from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'
import { trackExperimentViewed } from '@mc/track-event'
import { Motivation } from 'pages/find-my-classes/hooks/useCategorySelections'
import { QUIZ_OUTCOME_FRAMING_I18N_NAMESPACE } from './i18n'

// https://app.growthbook.io/features/pen-5819_v1
const FLAG = 'pen-5819_v1'

export const useQuizOutcomeFramingExp = () => {
  const { t } = useTranslation(QUIZ_OUTCOME_FRAMING_I18N_NAMESPACE)

  useEffect(() => {
    trackExperimentViewed(FLAG)
  }, [])

  const bucket = useBucket(FLAG)

  const getQuizOutcomeFramingMotivationCopy = useCallback(
    (motivation: Motivation) => {
      if (!bucket || bucket === 'control') return undefined
      return t(`options.${motivation}`)
    },
    [bucket, t],
  )

  return {
    title: bucket === 'variant_1' ? t('title') : undefined,
    getQuizOutcomeFramingMotivationCopy,
  }
}
